import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { SitesObject } from 'src/app/models/orders/order-details-sites/sites-tab-object-model';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-format-selection',
  templateUrl: './format-selection.component.html',
  styleUrls: ['./format-selection.component.css']
})
export class FormatSelectionComponent implements OnChanges {

  @Input() sites: Array<SitesObject>;
  @Input() formatsList: Array<string>;
  @Input() dataSourceId: number;
  formatName: string = '';
  dataSourceIdSubscription: Subscription;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!isNullOrUndefined(changes.sites)) {
      this.updateFormatsInfo();
    }
  }

  public changeAddressFormat(format: string) {
    this.formatName = format;
  }

  public updateFormatsInfo() {
    if (!isNullOrUndefined(this.sites) && this.sites.length > this.dataSourceId) {
      this.formatsList = this.sites[this.dataSourceId].getAllFormats();
      if (this.formatsList.length > 0) {
        this.changeAddressFormat(this.formatsList[0]);
      }
    }
  }

}
